import { useState, useCallback } from "react";
import { message } from "antd";
import { OVIZIA_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";
import { revertContentVersion } from "./contentApi";


const BASE_URL = OVIZIA_SERVICE_BASE_URL;

export function useWebsiteVersions(websiteId) {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reverting, setReverting] = useState(false);

  const fetchVersions = useCallback(async () => {
    if (!websiteId) return;
    setLoading(true);
    try {
      const { data } = await apiClient.get(
        `/api/v1/websites/${websiteId}/content/all`,
        { baseURL: BASE_URL },
      );
      const sorted = [...data].sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
      );
      setVersions(sorted);
    } catch (err) {
      message.error("Failed to load version history");
    } finally {
      setLoading(false);
    }
  }, [websiteId]);

  const revertToVersion = useCallback(
    async (versionId) => {
      setReverting(true);
      try {
        await revertContentVersion(websiteId, versionId);
        message.success("Reverted to this version");
        await fetchVersions();
      } catch (err) {
        message.error("Failed to revert. Please try again.");
        throw err;
      } finally {
        setReverting(false);
      }
    },
    [websiteId, fetchVersions],
  );

  return { versions, loading, reverting, fetchVersions, revertToVersion };
}